/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsmessagedeleted2Inputs */

const en_groupsmessagedeleted2 = /** @type {(inputs: Groupsmessagedeleted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message deleted`)
};

const de_groupsmessagedeleted2 = /** @type {(inputs: Groupsmessagedeleted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht gelöscht`)
};

/**
* | output |
* | --- |
* | "Message deleted" |
*
* @param {Groupsmessagedeleted2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsmessagedeleted2 = /** @type {((inputs?: Groupsmessagedeleted2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsmessagedeleted2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsmessagedeleted2(inputs)
	return de_groupsmessagedeleted2(inputs)
});
export { groupsmessagedeleted2 as "groupsMessageDeleted" }